import { render } from "./MyProjectItem.vue?vue&type=template&id=48e1c41f"
import script from "./MyProjectItem.vue?vue&type=script&lang=js"
export * from "./MyProjectItem.vue?vue&type=script&lang=js"

import "./MyProjectItem.vue?vue&type=style&index=0&id=48e1c41f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__